module.exports = __webpack_public_path__ + "img/appltCourse-img6.bc0a8aa9.png";